export default __webpack_public_path__ + "static/python-icon-684e81d417530a4d99ec207869861546.png";